module.exports = __webpack_public_path__ + "static/media/world_wide_web_group.75370c47.svg";